export default __webpack_public_path__ + "static/media/rectangle-30.7aa02a5f.svg";